import {
	RegressionAssertType,
	RegressionFileQuantityType,
	type RegressionAssertProperty,
	type RegressionInvestmentCompanyOption,
	type RegressionSessionStateOption,
	type RegressionTestTypeOption,
	type RegressionTestableFeature,
} from './types';

export const regressionTestTypeOptions: RegressionTestTypeOption[] = [
	{
		testTypeId: 1,
		testTypeName: '180',
		inputFileQuantityTypeId: RegressionFileQuantityType.Single,
		outputFileQuantityTypeId: RegressionFileQuantityType.Single,
	},
	{
		testTypeId: 2,
		testTypeName: '360',
		inputFileQuantityTypeId: RegressionFileQuantityType.Single,
		outputFileQuantityTypeId: RegressionFileQuantityType.Single,
	},
	{
		testTypeId: 3,
		testTypeName: 'Merge',
		inputFileQuantityTypeId: RegressionFileQuantityType.Multiple,
		outputFileQuantityTypeId: RegressionFileQuantityType.Single,
	},
	{
		testTypeId: 4,
		testTypeName: 'Split',
		inputFileQuantityTypeId: RegressionFileQuantityType.Single,
		outputFileQuantityTypeId: RegressionFileQuantityType.Multiple,
	},
];

export const regressionDatabaseOptions = ['5', '504'];

export const regressionDateFormatOptions = [
	'yyyyMMdd',
	'MM/dd/yyyy',
	'MMddyyyy',
	'MMddyy',
	'yyyy-MM-dd',
	'MM-dd-yyyy',
	'yyyyMM',
];

export const regressionPayrollCompanies = [
	'Accountix',
	'Alliance HCM',
	'APS',
	'Asure',
	'Asure Mangrove',
	'CheckWriters',
	'Cyberpay',
	'DM Payroll',
	'Empeon',
	'ExecuPay',
	'Execupay API',
	'Fingerchecks',
	'Gusto',
	'Harpers',
	'Heartland',
	'iSolved',
	'LumberFi',
	'Paycor',
	'PayDay',
	'People Guru',
	'PrismHR HCM',
	'PrismHR PEO',
	'Proliant',
	'Ready Pay',
	'Ripling',
	'SDP',
	'Trinet',
	'UKG',
	'Uzio',
];

export const regressionTestableFeatures: RegressionTestableFeature[] = [
	{ testableFeatureId: 1, name: 'Standard Baseline and Asserts' },
	{ testableFeatureId: 2, name: 'Default Loan Number' },
	{ testableFeatureId: 3, name: 'Deferral Start Date' },
];

export const regressionAssertProperties: RegressionAssertProperty[] = [
	'CompanyId',
	'DestinationId',
	'OriginalFileName',
	'OutboundFileName',
	'PlanId',
	'StateId',
];

export const regressionAssertTypeOptions = [
	RegressionAssertType.Equals,
	RegressionAssertType.True,
	RegressionAssertType.Contains,
];

const regressionInvestmentCompanyOptionsUnsorted: RegressionInvestmentCompanyOption[] = [
	{ investmentCompanyMasterId: 1, companyName: 'ADP', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 2, companyName: 'American Funds', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 3, companyName: 'John Hancock', defaultPayrollDateFormat: 'MMddyyyy' },
	{ investmentCompanyMasterId: 4, companyName: 'Transamerica', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 5, companyName: 'American Funds IRA', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 6, companyName: 'Mass Mutual Sparks', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 7, companyName: 'Lincoln', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 8, companyName: 'Nationwide', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 9, companyName: 'One America', defaultPayrollDateFormat: 'MM/dd/yyy' },
	{ investmentCompanyMasterId: 10, companyName: 'Empower/American Funds Premier', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 11, companyName: 'Principal', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 12, companyName: 'Mass Mutual DERD', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 13, companyName: 'Voya', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 14, companyName: 'Ameritas', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 15, companyName: 'Ascensus', defaultPayrollDateFormat: 'MMddyyyy' },
	{ investmentCompanyMasterId: 16, companyName: 'Blue Star', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 17, companyName: 'BPAS', defaultPayrollDateFormat: 'MMddyyyy' },
	{ investmentCompanyMasterId: 18, companyName: 'Envoy', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 19, companyName: 'EPlan Services', defaultPayrollDateFormat: 'MM-dd-yyyy' },
	{ investmentCompanyMasterId: 20, companyName: 'Erisa', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 21, companyName: 'Fidelity', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 22, companyName: 'Mutual of America', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 23, companyName: 'PCS', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 24, companyName: 'Pentegra', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 25, companyName: 'Swerdlin', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 26, companyName: 'Valic', defaultPayrollDateFormat: 'MMddyyyy' },
	{ investmentCompanyMasterId: 27, companyName: 'ABG', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 28, companyName: 'Prudential', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 29, companyName: 'Sentinel', defaultPayrollDateFormat: 'MMddyyyy' },
	{ investmentCompanyMasterId: 30, companyName: 'Securian', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 31, companyName: 'TWG', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 32, companyName: 'Voya ADNO', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 33, companyName: 'SaveDay', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 35, companyName: 'Cuna Mutual', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 36, companyName: 'PAi', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 37, companyName: 'TIAA', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 38, companyName: 'Unified Trust', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 39, companyName: 'T.Rowe Price', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 40, companyName: 'Vestwell', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 41, companyName: 'Human Interest', defaultPayrollDateFormat: 'yyyy-MM-dd' },
	{ investmentCompanyMasterId: 42, companyName: 'Standard', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 43, companyName: 'Epic', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 44, companyName: 'Alerus', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 45, companyName: '401Go', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 46, companyName: 'Stanley Benefits', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 47, companyName: 'July Services', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 48, companyName: 'Nyhart', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 49, companyName: 'SS&C', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 50, companyName: 'Principal IRT', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 51, companyName: 'RPG', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 52, companyName: 'AMI', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 53, companyName: 'TRPC', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 54, companyName: 'APB', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 55, companyName: 'Schwab', defaultPayrollDateFormat: 'MMddyyyy' },
	{ investmentCompanyMasterId: 56, companyName: 'Employee Fiduciary', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 57, companyName: 'CMC', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 58, companyName: 'Ubiquity', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 59, companyName: 'Intrust', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 60, companyName: 'Ease', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 61, companyName: 'Morgan White', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 62, companyName: 'Fulton Bank', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 63, companyName: 'KTrade', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 64, companyName: 'Newport', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 65, companyName: 'Peoples Bank', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 66, companyName: 'FBSI', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 67, companyName: 'TRI AD', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 68, companyName: 'Mass Mutual Legacy', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 70, companyName: 'Slavic', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 71, companyName: 'Merril Lynch', defaultPayrollDateFormat: 'MMddyy' },
	{ investmentCompanyMasterId: 72, companyName: 'TAG', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 73, companyName: 'Sheakley', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 74, companyName: 'Alight', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 75, companyName: 'NBS', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 76, companyName: 'Alliance', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 78, companyName: 'Greenleaf', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 79, companyName: 'T Bank', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 80, companyName: 'TCG', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 81, companyName: 'Benefits Consultants', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 82, companyName: 'inVesti Financial', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 83, companyName: 'Ohio National', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 84, companyName: 'NWPS', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 85, companyName: 'Vanguard', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 86, companyName: 'Sentry', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 87, companyName: 'Heartland', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 88, companyName: 'Prosper', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 90, companyName: 'Generic Ahola', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 91, companyName: 'Leading Retirment', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 92, companyName: 'USI', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 93, companyName: 'BOK Financial', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 94, companyName: 'Chemung', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 95, companyName: 'Guidestone', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 96, companyName: 'Milliman', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 97, companyName: 'Retirment Plan Consultants', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 98, companyName: 'Bank Of America', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 99, companyName: 'Bernie Portal', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 100, companyName: 'IRA Logix', defaultPayrollDateFormat: 'yyyy-MM-dd' },
	{ investmentCompanyMasterId: 101, companyName: 'UBT', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 102, companyName: 'IPX Retirment', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 103, companyName: 'New England Pension', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 104, companyName: 'TPP', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 105, companyName: 'Concord', defaultPayrollDateFormat: 'yyyyMM' },
	{ investmentCompanyMasterId: 107, companyName: 'Avantax', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 108, companyName: 'Betterment', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 109, companyName: 'Alight 2', defaultPayrollDateFormat: 'yyyyMMdd' },
	{ investmentCompanyMasterId: 110, companyName: 'Randall & Hurley', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 111, companyName: 'Pension Inc', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 112, companyName: 'PenCorp', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 113, companyName: 'NestEggs', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 114, companyName: 'Journy RPS', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 115, companyName: 'Certified Benefits Corp', defaultPayrollDateFormat: 'MM/dd/yyyy' },
	{ investmentCompanyMasterId: 116, companyName: 'Elevate 401k', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 117, companyName: 'Guideline', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 118, companyName: 'Howard Simon', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 119, companyName: 'Future Plan', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 120, companyName: 'Corebridge', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 121, companyName: 'No Transform', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 122, companyName: 'Pattillo Brown Hill (PB&H)', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 123, companyName: 'First Merchants', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 124, companyName: 'Paychex', defaultPayrollDateFormat: null },
	{ investmentCompanyMasterId: 125, companyName: 'NestEggU', defaultPayrollDateFormat: null },
];

export const regressionInvestmentCompanyOptions = [...regressionInvestmentCompanyOptionsUnsorted].sort((left, right) =>
	left.companyName.localeCompare(right.companyName)
);

export const regressionSessionStateOptions: RegressionSessionStateOption[] = [
	{ stateId: 1, stateDescription: 'Accepting File' },
	{ stateId: 2, stateDescription: 'Accepted File' },
	{ stateId: 3, stateDescription: 'Processing Started' },
	{ stateId: 4, stateDescription: 'Processing Complete' },
	{ stateId: 5, stateDescription: 'Ftp Complete' },
	{ stateId: 6, stateDescription: 'Confirmed' },
	{ stateId: 7, stateDescription: 'Upload Skipped' },
	{ stateId: 8, stateDescription: 'Confirmation Received' },
	{ stateId: 9, stateDescription: 'Confirming' },
	{ stateId: 10, stateDescription: 'Confirmation Processed' },
	{ stateId: 11, stateDescription: 'File Sent' },
	{ stateId: 12, stateDescription: 'Error Cleared' },
	{ stateId: 13, stateDescription: 'Error Overridden' },
	{ stateId: 14, stateDescription: 'Review Required' },
	{ stateId: 15, stateDescription: 'Importing Data' },
	{ stateId: 16, stateDescription: 'Imported Data' },
	{ stateId: 17, stateDescription: 'Approved' },
	{ stateId: 18, stateDescription: 'Email Complete' },
	{ stateId: 20, stateDescription: 'Pending Download' },
	{ stateId: 21, stateDescription: 'File Downloaded' },
	{ stateId: 25, stateDescription: 'Pending API call' },
	{ stateId: 26, stateDescription: 'API call complete' },
	{ stateId: 29, stateDescription: 'Queued To Send Email' },
	{ stateId: 30, stateDescription: 'Queued To Send' },
	{ stateId: 31, stateDescription: 'File Ready To Move' },
	{ stateId: 32, stateDescription: 'Queued For Pickup' },
	{ stateId: 33, stateDescription: 'Queued For Pickup' },
	{ stateId: 34, stateDescription: 'File Picked up' },
	{ stateId: 35, stateDescription: 'Queued for Delete (Re-Process)' },
	{ stateId: 36, stateDescription: 'Queued for Delete (Merge)' },
	{ stateId: 37, stateDescription: 'Queued for Delete (Abort)' },
	{ stateId: 38, stateDescription: 'Queued To Send by Api' },
	{ stateId: 39, stateDescription: 'Queued To Pull by Api' },
	{ stateId: 40, stateDescription: 'Files Received' },
	{ stateId: 41, stateDescription: 'Files Merged' },
	{ stateId: 42, stateDescription: 'Writing File(s)' },
	{ stateId: 43, stateDescription: 'Output File Created' },
	{ stateId: 44, stateDescription: 'File to be Merged' },
	{ stateId: 45, stateDescription: 'File Split' },
	{ stateId: 46, stateDescription: 'No Detail Records' },
	{ stateId: 47, stateDescription: 'Data Read' },
	{ stateId: 48, stateDescription: 'Post Process Complete' },
	{ stateId: 49, stateDescription: 'Validation Analysis Completed' },
	{ stateId: 50, stateDescription: 'FTP Confirmed' },
	{ stateId: 51, stateDescription: 'Ftp Retry' },
	{ stateId: 60, stateDescription: 'FTP Delay Removed' },
	{ stateId: 61, stateDescription: 'Sending' },
	{ stateId: 70, stateDescription: 'No Data to process' },
	{ stateId: 71, stateDescription: 'No Records Written' },
	{ stateId: 80, stateDescription: 'Manual Verification Required' },
	{ stateId: 85, stateDescription: 'Matched to Plan' },
	{ stateId: 90, stateDescription: 'Duplicate File' },
	{ stateId: 91, stateDescription: 'No Match Found' },
	{ stateId: 92, stateDescription: 'Confirmation Error' },
	{ stateId: 93, stateDescription: 'FTP Delay' },
	{ stateId: 94, stateDescription: 'File Aborted' },
	{ stateId: 95, stateDescription: 'Validation Failed' },
	{ stateId: 97, stateDescription: 'Error Reading Receipt' },
	{ stateId: 98, stateDescription: 'Error processing file' },
	{ stateId: 99, stateDescription: 'File Transfer Failed' },
	{ stateId: 180, stateDescription: 'Manual Verification (No Legal Code)' },
	{ stateId: 181, stateDescription: 'Manual Verification (No Pay Item)' },
	{ stateId: 189, stateDescription: 'Plan Disabled' },
	{ stateId: 190, stateDescription: 'Unable to Confirm' },
	{ stateId: 191, stateDescription: 'Errors Returned' },
	{ stateId: 192, stateDescription: 'Errors Returned (No summary)' },
	{ stateId: 199, stateDescription: 'File Already Exists' },
	{ stateId: 200, stateDescription: 'File Split' },
	{ stateId: 300, stateDescription: 'Data To Import' },
	{ stateId: 301, stateDescription: 'Data Imported' },
];